import * as types from 'models/actionTypes'

export const requestStatus = () => ({
    type: types.REQUEST_STATUS,
})

export const receiveStatus = (status) => ({
    type: types.RECEIVE_STATUS,
    status,
})

export const failedReceiveStatus = () => ({
    type: types.FAILED_RECEIVE_STATUS,
})
